import { Maybe } from '@/utils/types'
import { isDefined } from './primitives/generics'

export function getItemOrFirstEntry<T>(param: T | T[]): T | undefined {
  if (Array.isArray(param)) {
    if (param.length > 0) return param[0]!
    else return undefined
  } else {
    return param
  }
}

export function arrayify<T>(param: T | T[]): T[] {
  if (Array.isArray(param)) {
    return param
  } else {
    return [param]
  }
}

export function mergeArrays<T = unknown>(...arrs: (T[] | undefined)[]): T[] {
  return arrs.flat().filter(isDefined)
}

export function removeNullishValues<T>(value: Maybe<Maybe<T>[]>): T[] {
  return value?.filter((v): v is T => v !== null && v !== undefined) ?? []
}
